import { render, staticRenderFns } from "./PlatformActions.vue?vue&type=template&id=423d9068"
import script from "./PlatformActions.vue?vue&type=script&lang=js"
export * from "./PlatformActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports